<template>
  <div>
    <v-text-field
      ref="search"
      @input="inputKeyword"
      append-icon="search"
      placeholder="検索"
      background-color="white"
      solo
      class="search-box"
    />
  </div>
</template>

<script>
import debounce from 'lodash/debounce'

export default {
  name: 'MapReportRequestSearchBox',
  mounted() {
    this.$refs.search.focus()
  },
  methods: {
    inputKeyword: debounce(function(keyword) {
      this.$emit('onTextEnter', keyword)
    }, 1000),
  },
}
</script>

<style>
.search-box {
  max-width: 250px;
}
</style>
